module.exports = __webpack_public_path__ + "g.no1.7ca2f402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/g.no1.jpg
// module id = adNE
// module chunks = 0